import React from 'react'
import "./Top_performance.css"
import Common_section_heading from '../../common_components/common_heading/common_section_heading/Common_section_heading'
import { Button } from 'react-bootstrap'
import First_winner_lottie from '../../animations/first_winner_lottie/First_winner_lottie'

function Top_performance() {
    return (
        <>
            <section className='Top_performance section_margin'>
                <div className="container">

                    <Common_section_heading title="TODAY’S TOP 3 PERFORMERS" subTitle="Celebrating excellence and recognizing our star members of the day." />

                    <div className="performers_holder">
                        <div className="row align-items-end justify-content-center">
                            <div className="col-xl-3 col-md-4 col-4">
                                <div className="performer_card_holder second_winner">

                                    <div className="performers_img_holder">
                                        <div className="img_holder second_performer">
                                            <img src="/assets/images/home/top_performance/second_winner.png" alt="" className='performers_img' />
                                        </div>
                                    </div>

                                    <div className='performers_price'>
                                        <p>₹. 4578932</p>
                                    </div>
                                    <div className="performance_name">
                                        <p>Alena Bator</p>
                                    </div>

                                    <div className="btn_holder">
                                        <Button className="say_congrats">Say Congrats</Button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3  col-md-4 col-4">
                               
                                <div className="performer_card_holder first_winner">

                                    <div className="performers_img_holder">
                                        <div className="img_holder first_performer">
                                            <img src="/assets/images/home/top_performance/first_winner.png" alt="" className='performers_img' />
                                        </div>
                                         <First_winner_lottie/>
                                    </div>

                                    <div className='performers_price'>
                                        <p>₹. 4578932</p>
                                    </div>
                                    <div className="performance_name">
                                        <p>Alena Bator</p>
                                    </div>

                                    <div className="btn_holder">
                                        <Button className="say_congrats">Say Congrats</Button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-3  col-md-4 col-4">
                                <div className="performer_card_holder third_winner">

                                    <div className="performers_img_holder">
                                        <div className="img_holder third_performer">
                                            <img src="/assets/images/home/top_performance/third_winner.png" alt="" className='performers_img' />
                                        </div>
                                    </div>

                                    <div className='performers_price'>
                                        <p>₹. 4578932</p>
                                    </div>
                                    <div className="performance_name">
                                        <p>Alena Bator</p>
                                    </div>

                                    <div className="btn_holder">
                                        <Button className="say_congrats">Say Congrats</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Top_performance